export function isNullOrUndefined(
    valueToCheck: any
): valueToCheck is null | undefined {
    return typeof valueToCheck === "undefined" || valueToCheck === null;
}
